module.exports = __webpack_public_path__ + "static/northYorkHero-5ab11221e3a3b6c04367fe0d0688dc1f.jpg";